// Web-only strings for the threads package (2026-10-18 parity wave): requested acknowledgements
// (shared/API.md §41.3) and the who-saw-it dialog's chrome. BOTH languages. The follow control, the
// thread-or-conversation chooser, the typing slot, «Fijado» and the who-saw-it rows reuse the Apple
// keys (`threads.follow`, `channelList.threadChoice.*`, `channel.typing.*`, `channel.pinned.marker`,
// `channel.seen.*`).
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.ack.request': 'Solicitar confirmación',
    'web.ack.persistent': 'Notificar persistentemente',
    'web.ack.persistent.footer': 'Se repite el aviso hasta que confirmen. Solo con «Urgente».',
    'web.ack.willRequest': 'Se pedirá confirmación de lectura',
    'web.ack.willRequestPersistent': 'Se pedirá confirmación y se avisará hasta que confirmen',
    'web.ack.confirm': 'Confirmar',
    'web.ack.confirmed': 'Confirmado',
    'web.ack.undo': 'Deshacer confirmación',
    'web.ack.requested': 'Pide confirmación',
    'web.ack.count.none': 'Sin confirmaciones',
    'web.ack.count.one': '1 confirmación',
    'web.ack.count.many': '%d confirmaciones',
    'web.ack.listTitle': 'Confirmaciones',
    'web.ack.listEmpty': 'Nadie ha confirmado todavía.',
    'web.ack.failed': 'No se pudo confirmar el mensaje.',
    'web.ack.undoFailed': 'No se pudo deshacer la confirmación.',
    'web.ack.you': 'Tú',
    'web.thread.followFailed': 'No se pudo cambiar el seguimiento del hilo.',
    'web.thread.unfollowFromList': 'Dejar de seguir este hilo',
    'web.seen.open': 'Ver quién lo ha visto',
  },
  en: {
    'web.ack.request': 'Request acknowledgement',
    'web.ack.persistent': 'Send persistent notifications',
    'web.ack.persistent.footer': 'Recipients are reminded until they acknowledge. Urgent only.',
    'web.ack.willRequest': 'Acknowledgement will be requested',
    'web.ack.willRequestPersistent': 'Acknowledgement requested, with reminders until acknowledged',
    'web.ack.confirm': 'Acknowledge',
    'web.ack.confirmed': 'Acknowledged',
    'web.ack.undo': 'Undo acknowledgement',
    'web.ack.requested': 'Asks for acknowledgement',
    'web.ack.count.none': 'No acknowledgements',
    'web.ack.count.one': '1 acknowledgement',
    'web.ack.count.many': '%d acknowledgements',
    'web.ack.listTitle': 'Acknowledgements',
    'web.ack.listEmpty': 'Nobody has acknowledged yet.',
    'web.ack.failed': "Couldn't acknowledge the message.",
    'web.ack.undoFailed': "Couldn't undo the acknowledgement.",
    'web.ack.you': 'You',
    'web.thread.followFailed': "Couldn't change whether you follow the thread.",
    'web.thread.unfollowFromList': 'Unfollow this thread',
    'web.seen.open': 'See who has seen it',
  },
};
